
let InfoTab = require('app/seller/show/InfoTab');
let StatsTab = require('app/seller/show/StatsTab');
let RestaurantsTab = require('app/seller/show/RestaurantsTab');

class ShowView {
    defaultOptions() {
        return {
            'activeTab': 'info',
            'selector': '.view-seller-show',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }

    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'info':
                let infoTab = new InfoTab({
                    'seller': this.settings.seller,
                    '$container': $tabBody
                });
            break;
            case 'stats':
                let tabTab = new StatsTab({
                    'seller': this.settings.seller,
                    '$container': $tabBody
                });
            break;
            case 'restaurants':
                let restaurantsTab = new RestaurantsTab({
                    'seller': this.settings.seller,
                    '$container': $tabBody
                });
            break;
        }
    }

}

module.exports = ShowView;

